import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { EventService } from '@event/event.service';
import { Observable } from 'rxjs';

@Injectable()
export class EventInterceptor implements HttpInterceptor {
  private readonly eventService = inject(EventService);

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    const event = this.eventService.event();

    if (event) {
      if (request.url.startsWith(environment.backendUrl)) {
        request = request.clone({
          // eslint-disable-next-line @typescript-eslint/naming-convention
          setHeaders: { 'X-Event': event.uuid },
        });
      }
    }

    return next.handle(request);
  }
}
